import axios from 'axios';
import _ from 'lodash';
import { batchQuery, getDriversQuery, getHaulingCompaniesQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import Split from '../split';
import { resolveId } from '../../utils';

const getDriverListDetails = (id, includeDeleted) =>
    new Promise((resolve, reject) => {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const fields = ['created_at', 'deleted_at', 'email', 'hauling_id', 'id', 'name', 'updated_at', 'username', 'license_number', 'driver_number', 'permissions', 'expiry_date', 'inspection_date', 'hire_date', 'state_of_license'];
        const params = {
            fields,
            ...(!!id && { haulingId: id }),
            ...(includeDeleted !== undefined && { filterDeleted: !includeDeleted }),
        };
        const query = getDriversQuery({ ...params, queryBuilder });
        const request = axios.get(query);

        request
            .then((response) => {
                const drivers = Array.isArray(response.data) ? response.data.filter(Boolean).map(resolveId) : [];
                const haulingIds = _.uniq(_.compact(_.map(drivers, 'hauling_id')));

                const haulingCompanyQuery = batchQuery(
                    getHaulingCompaniesQuery,
                    {
                        filterDeleted: true,
                        fields: ['id', 'name'],
                        ids: haulingIds,
                        queryBuilder,
                    },
                    'ids'
                );
                const haulingCompanyRequest = _.map(haulingCompanyQuery, (q) => axios.get(q));

                axios.all(haulingCompanyRequest).then(
                    axios.spread((...responses) => {
                        const haulingCompanies = _.reduce(responses, (acc, val) => [...acc, ...(Array.isArray(val.data) ? val.data.filter(Boolean).map(resolveId) : [])], []);
                        const driverResponse = _.orderBy(
                            _.map(drivers, (driver) => {
                                const hauler = _.find(haulingCompanies, { id: driver.hauling_id });
                                const haulingCompany = hauler && hauler.name ? hauler.name : '';
                                return { ...driver, hauling_company: haulingCompany };
                            }),
                            ['name'],
                            ['asc']
                        );
                        resolve({ drivers: driverResponse });
                    })
                );
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getDriverListDetails;
